<template>
  <div class="asid-nav-box">
    <div class="first-menu">
      {{ firstMenu.name }}&nbsp;/&nbsp;{{ firstMenu.nameEn }}
    </div>
    <ul class="second-menu-list">
      <li
        v-for="item in secondMenu"
        :key="item.id"
        :class="{ active: asideActiveId === item.id }"
        @click="handleClick(item.id)"
      >
        {{ item.name }}
      </li>
    </ul>
    <div class="bottom-telephone">
      <img src="@/assets/images/tel.jpg" /><span
        >服务热线：<br />0551-63529118</span
      >
    </div>
  </div>
</template>

<script>
import { getMenuById } from "@/config/menus";

export default {
  name: "AsideNav",
  data() {
    return {
      firstMenu: {},
      secondMenu: [],
      asideActiveId: "",
      defaultId: "",
    };
  },
  watch: {
    $route: {
      immediate: true,
      handler(v) {
        let menuId = v.params?.menuId || v.query?.linkMenuId || sessionStorage.getItem("asideActiveId")|| ""
        let firstId = menuId.substring(0, 3);
        // 新闻搜索
        if(menuId === "local001001" || v.name === "search") {
          firstId = "local001";
          menuId = "local001001";
        }
        if (menuId) {
          //点击一级菜单
          if (menuId === this.firstMenu.id) {
            this.asideActiveId = this.defaultId = this.firstMenu.children[0].id;
            sessionStorage.setItem("asideActiveId", this.asideActiveId);
            return;
          }
          //点击二级菜单
          if (firstId !== this.firstMenu.id) {
            this.firstMenu = getMenuById(firstId) || [];
            this.defaultId = this.firstMenu.children[0].id;
            this.secondMenu = this.firstMenu?.children || [];
          }
          this.asideActiveId =
            this.secondMenu.find((menu) => menu.id === menuId)?.id || this.firstMenu.children[0].id;
          sessionStorage.setItem("asideActiveId", this.asideActiveId);
        }
      },
    },
  },
  methods: {
    handleClick(id) {
      if(id === "local001001") {
        return;
      }
      this.$router.push(`/index/lists/${id}`);
    },
  },
};
</script>

<style lang="scss" scoped>
.asid-nav-box {
  width: 230px;
  height: 610px;
  > * {
    width: 200px;
    color: #fff;
    font-size: 14px;
    line-height: 42px;
  }
  .first-menu {
    padding-left: 10px;
    background: #0268b3;
  }
  .second-menu-list {
    margin-top: 5px;
    > li {
      cursor: pointer;
      padding-left: 30px;
      height: 40px;
      background: url("../../../assets/images/news-li2.jpg") no-repeat center left;
      &:hover {
        background: url("../../../assets/images/news-li1.jpg") no-repeat center
          left;
      }
    }
    > .active {
      background: url("../../../assets/images/news-li1.jpg") no-repeat center left;
    }
  }
  .bottom-telephone {
    height: 45px;
    background: #33a6dc;
    margin-top: 10px;
    line-height: 18px;
    > span {
      padding-top: 4px;
      padding-left: 10px;
      display: inline-block;
      vertical-align: top;
    }
  }
}
</style>
